import { render } from "./ScrollToTopButton.vue?vue&type=template&id=20b8c834&scoped=true"
import script from "./ScrollToTopButton.vue?vue&type=script&lang=js"
export * from "./ScrollToTopButton.vue?vue&type=script&lang=js"

import "./ScrollToTopButton.vue?vue&type=style&index=0&id=20b8c834&scoped=true&lang=scss"

import exportComponent from "C:\\projects\\balkan-app-links\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20b8c834"]])

export default __exports__